import { nextTick, watchEffect } from 'vue'

export function watchEffectUntilStopped(fn: (stop: (() => void)) => boolean|void) {
  let hasExecuted = false

  const doStop = () => {
    if (hasExecuted) {  // doStop() has already been called. Don't do anything.
      return
    }
    hasExecuted = true
    nextTick(() => stop())
  }

  const stop = watchEffect(
    () => {
      if (hasExecuted) {
        return
      }

      if (fn(doStop) === true) {
        doStop()
      }
    }
  )

  return stop
}
